import AsyncDirective from "../async";

export default Vue => {
  Vue.directive(
    "tooltip",
    new AsyncDirective(
      () => import("./v-tooltip.vue"),
      module => module.default
    )
  );
};
